import React from 'react';

const MissionAndPromise = () => {
  return (
    <div className="w-full max-w-4xl mx-auto px-8 py-8 sm:px-6 lg:px-8">
      <div className="flex flex-col md:flex-row gap-8">

        {/* Mission Card */}
        <div className="w-full md:w-1/2 bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1 p-6">
          <h2 className="text-4xl font-bold text-gray-800 mb-2">Our Mission</h2>
          <hr className="border-t-2 border-blue-500 mb-4" />
          <p className="mb-4 text-gray-600">
            Our practice is working together to build life-long relationships between our staff and our patients by consistently providing our patients with compassion, excellence, and value.
          </p>
          <p className="mb-2 text-gray-700 font-semibold">To fulfill this mission, we are committed to:</p>
          <ul className="list-disc list-outside ml-5 text-gray-600 space-y-2">
            <li>Improving the lives of the children we serve by providing quality care in a child-centered environment.</li>
            <li>Listening to our young patients and their families whom we are privileged to serve.</li>
            <li>Guiding our patients along a path of optimal health and wellness.</li>
            <li>Continually pursuing excellence at all levels through continuing education.</li>
          </ul>
        </div>

        {/* Promise Card */}
        <div className="w-full md:w-1/2 bg-white border border-gray-200 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1 p-6">
          <h2 className="text-4xl font-bold text-gray-800 mb-2">Grand Promise</h2>
          <hr className="border-t-2 border-green-500 mb-4" />
          <ul className="list-disc list-outside ml-5 text-gray-600 space-y-4">
            <li>By trusting our team for the healthcare needs of your child/children, we promise to provide your family with the highest quality of care.</li>
            <li>Our professional staff will go the extra mile to respond to your healthcare needs and take care of them efficiently and timely.</li>
            <li>Our approach to healthcare is holistic. We treat the illness and educate our patients about a healthy lifestyle to achieve optimal health and well-being.</li>
            <li>All your concerns will be listened to patiently. Our providers will not only explain the medical condition and various treatment options but also help you make the best decision as per your cultural preference.</li>
            <li>We always strive to make your visit a smooth and pleasant experience and you can always trust us in times of your need.</li>
          </ul>
        </div>

      </div>
    </div>
  );
};

export default MissionAndPromise;
